<template>
    <b-modal id="schema-input-copy-picker-modal"
             :title="$t('다른 스키마에서 복사')"
             size="xl"
             hide-footer
             modal-class="default-modal"
             @show="onShow"
    >
        <p class="text-secondary small mb-3">
            다른 프로젝트에 등록된 스키마 입력 값을 골라 <strong>복사</strong>하면, 현재 질문 추가 폼에
            draft(초안)로 채워집니다. 저장은 직접 눌러야 반영됩니다.
        </p>

        <div class="d-flex align-items-center mb-3">
            <b-form-input v-model="search"
                          :placeholder="$t('키 이름 또는 프로젝트로 검색')"
                          debounce="200"
                          style="max-width: 360px"
            />
            <b-button variant="outline-secondary" size="sm" class="ml-2" :disabled="loading" @click="fetchData">
                {{ $t('새로고침') }}
            </b-button>
            <span class="ml-auto text-secondary small">{{ filteredItems.length }} / {{ items.length }}</span>
        </div>

        <div class="table-container">
            <b-table fixed
                     responsive
                     :items="filteredItems"
                     :fields="fields"
                     class="mb-0"
                     show-empty
                     :busy="loading"
            >
                <template #empty>
                    <page-empty-component
                        :text="$t('조회된 스키마 입력 값가 없습니다.')"
                        :loading="loading"
                        :loading-text="$t('스키마 입력 값 목록을 조회 중입니다.')"
                    />
                </template>

                <template #cell(key_name)="row">
                    <span v-b-tooltip.hover="row.value">{{ row.value }}</span>
                </template>
                <template #cell(project_id)="row">
                    <span v-b-tooltip.hover="projectText(row.value)">{{ projectText(row.value) }}</span>
                </template>
                <template #cell(value_type)="row">
                    <b-badge variant="dark" class="f-80">{{ valueTypeText(row.value) }}</b-badge>
                </template>
                <template #cell(is_required)="row">
                    <b-badge :variant="row.value ? 'success' : null" class="f-80">
                        {{ row.value ? $t('필수') : $t('선택') }}
                    </b-badge>
                </template>
                <template #cell(action)="data">
                    <b-button size="sm" variant="outline-primary" @click="select(data.item)">
                        {{ $t('복사') }}
                    </b-button>
                </template>
            </b-table>
        </div>
    </b-modal>
</template>

<script>
import {listInputKeys} from '@shared_utils/api/projectSchema';
import {getTargetProjectText} from '@shared/components/admin/pages/Management/common-data';
import {valueTypeOptions} from '@shared/components/admin/pages/Management/ProjectSchema/SchemaInput/data';
import PageEmptyComponent from '@shared/components/admin/components/common/PageEmptyComponent.vue';

export default {
    name: 'SchemaInputCopyPickerModal',
    components: {PageEmptyComponent},
    props: {
        // 프로젝트 표시명 변환용 (getTargetProjectText).
        projects: {
            type: [Array, null],
            default: null,
        },
    },
    data() {
        return {
            loading: false,
            items: [],
            search: '',
            fields: [
                {key: 'key_name', label: '키 이름', thStyle: {width: '180px'}, tdClass: ['text-truncate']},
                {key: 'project_id', label: '프로젝트', thStyle: {width: '220px'}, tdClass: ['text-truncate']},
                {key: 'value_type', label: '타입', thStyle: {width: '90px'}, thClass: ['th-center'], tdClass: ['td-center']},
                {key: 'is_required', label: '필수', thStyle: {width: '70px'}, thClass: ['th-center'], tdClass: ['td-center']},
                {key: 'action', label: '복사', thStyle: {width: '90px'}, thClass: ['th-center'], tdClass: ['td-center']},
            ],
        };
    },
    computed: {
        filteredItems() {
            const q = (this.search || '').trim().toLowerCase();
            if (!q) return this.items;
            return this.items.filter((it) => {
                const name = (it.key_name || '').toLowerCase();
                const proj = this.projectText(it.project_id).toLowerCase();
                return name.includes(q) || proj.includes(q);
            });
        },
    },
    methods: {
        projectText(projectId) {
            return getTargetProjectText(projectId, this.projects) || String(projectId ?? '');
        },
        valueTypeText(valueType) {
            return valueTypeOptions.find((o) => o.value === valueType)?.text ?? '-';
        },
        onShow() {
            this.search = '';
            this.fetchData();
        },
        async fetchData() {
            try {
                this.loading = true;
                // project_id 없이 전체 프로젝트의 입력 값을 조회한다(백엔드가 optional 필터).
                const res = await listInputKeys({params: {}});
                const {input_keys} = res.data || {};
                this.items = Array.isArray(input_keys) ? input_keys : [];
            } catch (e) {
                console.error(e);
                this.$EventBus.$emit('toast-failure', this.$t('스키마 입력 값 복사'), this.$t('스키마 입력 값 목록을 불러오는 중 오류가 발생했습니다. 개발 팀에 문의해주세요.'));
                this.items = [];
            } finally {
                this.loading = false;
            }
        },
        select(item) {
            // 부모(콘솔)가 질문 모달의 openAsCopy(id) 를 호출한다. 저장은 유저가 직접.
            this.$emit('select', item.id);
            this.$bvModal.hide('schema-input-copy-picker-modal');
        },
    },
};
</script>

<style scoped lang="scss">
</style>
